<template>
  <div id="auth-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
	 name: "auth",
};
</script>



// WEBPACK FOOTER //
// src/layout/Auth.vue